import { render } from "./slack-share-success.vue?vue&type=template&id=580b903a&lang=pug"
import script from "./slack-share-success.vue?vue&type=script&setup=true&lang=js"
export * from "./slack-share-success.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__